import { render, staticRenderFns } from "./MyProducts.vue?vue&type=template&id=0e8601f6&scoped=true"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"
import style0 from "./MyProducts.vue?vue&type=style&index=0&id=0e8601f6&prod&scoped=true&lang=css"
import style1 from "./MyProducts.vue?vue&type=style&index=1&id=0e8601f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8601f6",
  null
  
)

export default component.exports